import React from "react";
import { useNavigate } from "react-router-dom";
import InputGroup from "./InputGroup";

const Apply = () => {
	const navigate = useNavigate();
	return (
		<section className="apply-section">
			<div className="container">
				<button
					className="btn-base mb-4 back-btn"
					onClick={() => navigate(-1)}
				>
					Go Back
				</button>
				<h3 className="txt text-base text-center mb-3">
					yLaunch application form
				</h3>
				<h5 className="txt text-center">
					Please fill in the form with as much detail as available
				</h5>
				<div className="content">
					<br />
					<InputGroup label="How are you known and who is involved?" />
					<br />
					<br />
					<InputGroup label="Project Name:" />
					<br />
					<InputGroup label="Name core team:" />
					<br />
					<br />
					<br />
					<br />
					<InputGroup label="Project information" />
					<br />
					<InputGroup label="Litepaper/Whitepaper link:" />
					<br />
					<InputGroup label="Project tokenomics:" />
					<br />
					<InputGroup label="Brief project Description:" />
					<br />
					<InputGroup label="Legal letter (link):" />
					<br />
					<br />
					<InputGroup label="Web & Social presence" />
					<br />
					<InputGroup label="Website URL" />
					<br />
					<br />
					<InputGroup label="Twitter Handle (@)" />
					<br />
					<InputGroup label="Project Telegram" />
					<br />
					<br />
					<InputGroup label="Fundraising & Expectations" />
					<br />
					<InputGroup label="Fund raising so far?" />
					<br />
					<InputGroup label="(If yes how much)" />
					<br />
					<br />
					<InputGroup label="Fundraising expectations on yLaunch?" />
					<br />
					<InputGroup label="Contact method" />
					<br />
					<button className="btn btn-base w-100" type="submit">
						Submit
					</button>
				</div>
			</div>
		</section>
	);
};

export default Apply;
